import type { Location } from 'react-router-dom';

import { Accordion, CustomIcon } from '~components/index';
import SidebarItem from './SidebarItem';

const sidebarInfoHandler = (
  item: Sidebar,
  location: Location,
  level: number
) => {
  if (item.children.length === 0) {
    return (
      <div key={item.id} className={level > 0 ? 'sidebar_identation' : ''}>
        <SidebarItem data={item} location={location} />
      </div>
    );
  } else {
    return (
      <div
        key={`sidebar_parent_${item.id}`}
        className={level > 0 ? 'sidebar_identation' : ''}
      >
        <Accordion
          data={[item]}
          header={(item) => {
            return (
              <div className="d-flex align-items-center">
                <CustomIcon name={item.icon} />
                <p className="text-break ms-2">{item.label}</p>
              </div>
            );
          }}
          body={({ children }) => (
            <div className="d-flex flex-column gap-1 mt-1">
              {children.map((child) =>
                sidebarInfoHandler(child, location, level + 1)
              )}
            </div>
          )}
          type="light"
          isSidebar
        />
      </div>
    );
  }
};

export const sidebarItemsRender = (data: Sidebar[], location: Location) => (
  <div className="sidebar_items my-2">
    {data.map((item) => sidebarInfoHandler(item, location, 0))}
  </div>
);
